module.exports = __webpack_public_path__ + "static/media/residenziale-affitto.070c793a.jpg";